import React from 'react';
import PurchaseRequestDetail from '../../components/PurchaseRequest/PurchaseRequestDetail';

const PurchaseRequestDetailPage = () => {
  return <PurchaseRequestDetail />;
};

export default PurchaseRequestDetailPage;